import { RiArrowLeftSLine } from '@remixicon/react'
import type { ReactNode } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export interface BreadcrumbItem {
    label: string
    path: string
}

interface Props {
    title?: string
    subtitle?: string
    breadcrumbItems?: BreadcrumbItem[]
    badgeNode?: ReactNode
    children?: ReactNode
    showGoBack?: boolean
    onGoBack?: () => void
}

export default function HeaderPageSection({
    title,
    subtitle,
    breadcrumbItems,
    badgeNode,
    children,
    showGoBack = true,
    onGoBack,
}: Props) {
    const navigate = useNavigate()

    return (
        <div className="flex justify-between items-center w-full">
            <div className="flex flex-col">
                {breadcrumbItems && breadcrumbItems.length > 0 && (
                    <nav aria-label="Breadcrumb" className="mb-2">
                        <ol className="flex items-center gap-2 text-sm text-[#475569]">
                            {breadcrumbItems.map((item, index) => (
                                <li key={index} className="flex items-center gap-2">
                                    <Link
                                        to={item.path}
                                        className={
                                            index === breadcrumbItems.length - 1
                                                ? 'font-semibold text-ebony-950'
                                                : ''
                                        }
                                    >
                                        {item.label}
                                    </Link>
                                    {index < breadcrumbItems.length - 1 && (
                                        <span className="text-gray-400">/</span>
                                    )}
                                </li>
                            ))}
                        </ol>
                    </nav>
                )}
                <div className="flex flex-col">
                    <div className="text-[#070A13] text-[32px] font-semibold flex items-center gap-4 leading-tight">
                        {showGoBack && (
                            <button
                                onClick={() => onGoBack ? onGoBack() : navigate(-1)}
                                className="text-gray-500 hover:text-gray-700 transition-colors"
                                aria-label="Atrás"
                            >
                                <RiArrowLeftSLine size={24} />
                            </button>
                        )}
                        {title && <h1>{title}</h1>}
                        {badgeNode && badgeNode}
                    </div>
                    {subtitle && (
                        <p className="text-[#667085] text-sm font-normal mt-1">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
            <div className="flex items-center gap-4">{children}</div>
        </div>
    )
}
